module.exports = __webpack_public_path__ + "img/SKMJ_limit9.bbf8473b.jpg";